import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Upload } from '@ceres/domain';

@Component({
    selector: 'ceres-upload-progress',
    templateUrl: './upload-progress.component.html',
    styleUrls: ['./upload-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UploadProgressComponent {
    @Input() fileUploads: Upload[];
}
